import RewardOptions from 'components/pages/RewardOptions/RewardOptions';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('redeem');
export default buildPage(RewardOptions, {
  requiresAuthentication: true,
  metaData: {
    title: 'Reward Options',
    description: 'Reward Options',
  },
});
